import EventEmitter from "eventemitter3";
import fetch from "isomorphic-fetch";
import queryString from "query-string";

//#region src/services/admin.ts
const user$1 = (sdk) => {
	const { sdkConfig: { url }, defaultVersion } = sdk;
	const httpClient = sdk.httpClient;
	return {
		getUser: async (userId) => {
			const endpoint = `${url}/${defaultVersion}/admin/users/${userId}`;
			return (await httpClient.get(endpoint)).data;
		},
		getUserByQuery: async (query) => {
			const endpoint = `${url}/${defaultVersion}/admin/users`;
			return (await httpClient.get(endpoint, { query })).data;
		},
		updateUser: async (userId, payload) => {
			const endpoint = `${url}/${defaultVersion}/admin/users/${userId}`;
			return (await httpClient.put(endpoint, { payload })).data;
		}
	};
};
var admin_default = user$1;

//#endregion
//#region src/models/responses/Ai.ts
let StreamAIEventType = /* @__PURE__ */ function(StreamAIEventType$1) {
	StreamAIEventType$1["MESSAGE_CHUNK"] = "message_chunk";
	StreamAIEventType$1["DONE"] = "done";
	StreamAIEventType$1["ERROR"] = "error";
	StreamAIEventType$1["METADATA"] = "metadata";
	StreamAIEventType$1["TITLE_UPDATE"] = "title_update";
	StreamAIEventType$1["MESSAGE_METADATA"] = "message_metadata";
	StreamAIEventType$1["DOCUMENT_START"] = "document_start";
	StreamAIEventType$1["DOCUMENT_TITLE"] = "document_title";
	StreamAIEventType$1["DOCUMENT_CHUNK"] = "document_chunk";
	StreamAIEventType$1["DOCUMENT_END"] = "document_end";
	StreamAIEventType$1["DOCUMENT_METADATA"] = "document_metadata";
	StreamAIEventType$1["DOCUMENT_ERROR"] = "document_error";
	StreamAIEventType$1["TOOL_USE_GENERATION_START"] = "tool_use_generation_start";
	StreamAIEventType$1["TOOL_USE_GENERATION_END"] = "tool_use_generation_end";
	StreamAIEventType$1["TOOL_USE_EXECUTION_START"] = "tool_use_execution_start";
	StreamAIEventType$1["TOOL_USE_EXECUTION_END"] = "tool_use_execution_end";
	StreamAIEventType$1["PODCAST_GENERATION_START"] = "podcast_generation_start";
	StreamAIEventType$1["COMPACTION_START"] = "compaction_start";
	StreamAIEventType$1["COMPACTION_END"] = "compaction_end";
	return StreamAIEventType$1;
}({});
let GeneratedArtifactType = /* @__PURE__ */ function(GeneratedArtifactType$1) {
	GeneratedArtifactType$1["DOCUMENT"] = "document";
	GeneratedArtifactType$1["IMAGE"] = "image";
	GeneratedArtifactType$1["PODCAST"] = "podcast";
	GeneratedArtifactType$1["CORRECTION"] = "correction";
	return GeneratedArtifactType$1;
}({});
let GeneratedPodcastStageStatus = /* @__PURE__ */ function(GeneratedPodcastStageStatus$1) {
	GeneratedPodcastStageStatus$1["LOADING"] = "loading";
	GeneratedPodcastStageStatus$1["READY"] = "ready";
	GeneratedPodcastStageStatus$1["ERROR"] = "error";
	return GeneratedPodcastStageStatus$1;
}({});

//#endregion
//#region src/utils/stream.ts
var AssistantStreamEmitter = class extends EventEmitter {};
const processStream = (stream) => {
	const eventsEmitter = new AssistantStreamEmitter();
	const reader = stream.getReader();
	const decoder = new TextDecoder("utf-8");
	let generatedContent = "";
	let startReadingCalled = false;
	let bufferedEvent = "";
	function readChunk() {
		reader.read().then(({ done, value }) => {
			if (done) {
				reader.releaseLock();
				return;
			}
			const event = decoder.decode(value, { stream: true });
			bufferedEvent += event;
			const events = bufferedEvent.split("\n\n<END_OF_EVENT>\n");
			bufferedEvent = events.pop() || "";
			for (const currentEvent of events) {
				var _eventPayload$;
				if (!currentEvent.trim()) continue;
				const eventPayload = currentEvent.split("\ndata: ");
				const eventType = ((_eventPayload$ = eventPayload[0]) !== null && _eventPayload$ !== void 0 ? _eventPayload$ : "").replace("event: ", "").trim();
				const eventData = eventPayload.length > 1 ? eventPayload.slice(1).join("\ndata: ") : void 0;
				let hasParsedData = false;
				let parsedData;
				const requireParsedData = () => {
					if (!eventData) throw new Error(`Missing data for event type: ${eventType}`);
					if (!hasParsedData) {
						parsedData = JSON.parse(eventData);
						hasParsedData = true;
					}
					return parsedData;
				};
				try {
					switch (eventType) {
						case StreamAIEventType.MESSAGE_CHUNK: {
							const data = requireParsedData();
							generatedContent += data.chunk;
							eventsEmitter.emit(StreamAIEventType.MESSAGE_CHUNK, data);
							break;
						}
						case StreamAIEventType.METADATA:
							eventsEmitter.emit(StreamAIEventType.METADATA, requireParsedData());
							break;
						case StreamAIEventType.TITLE_UPDATE:
							eventsEmitter.emit(StreamAIEventType.TITLE_UPDATE, requireParsedData());
							break;
						case StreamAIEventType.MESSAGE_METADATA:
							eventsEmitter.emit(StreamAIEventType.MESSAGE_METADATA, requireParsedData());
							break;
						case StreamAIEventType.DOCUMENT_START:
							eventsEmitter.emit(StreamAIEventType.DOCUMENT_START);
							break;
						case StreamAIEventType.DOCUMENT_TITLE:
							eventsEmitter.emit(StreamAIEventType.DOCUMENT_TITLE, requireParsedData());
							break;
						case StreamAIEventType.DOCUMENT_CHUNK:
							eventsEmitter.emit(StreamAIEventType.DOCUMENT_CHUNK, requireParsedData());
							break;
						case StreamAIEventType.DOCUMENT_END:
							eventsEmitter.emit(StreamAIEventType.DOCUMENT_END);
							break;
						case StreamAIEventType.DOCUMENT_METADATA:
							eventsEmitter.emit(StreamAIEventType.DOCUMENT_METADATA, requireParsedData());
							break;
						case StreamAIEventType.DOCUMENT_ERROR:
							eventsEmitter.emit(StreamAIEventType.DOCUMENT_ERROR);
							break;
						case StreamAIEventType.TOOL_USE_GENERATION_START:
							eventsEmitter.emit(StreamAIEventType.TOOL_USE_GENERATION_START, requireParsedData());
							break;
						case StreamAIEventType.TOOL_USE_GENERATION_END:
							eventsEmitter.emit(StreamAIEventType.TOOL_USE_GENERATION_END, requireParsedData());
							break;
						case StreamAIEventType.TOOL_USE_EXECUTION_START:
							eventsEmitter.emit(StreamAIEventType.TOOL_USE_EXECUTION_START, requireParsedData());
							break;
						case StreamAIEventType.TOOL_USE_EXECUTION_END:
							eventsEmitter.emit(StreamAIEventType.TOOL_USE_EXECUTION_END, requireParsedData());
							break;
						case StreamAIEventType.PODCAST_GENERATION_START:
							eventsEmitter.emit(StreamAIEventType.PODCAST_GENERATION_START, requireParsedData());
							break;
						case StreamAIEventType.COMPACTION_START:
							eventsEmitter.emit(StreamAIEventType.COMPACTION_START);
							break;
						case StreamAIEventType.COMPACTION_END:
							eventsEmitter.emit(StreamAIEventType.COMPACTION_END);
							break;
						case StreamAIEventType.DONE:
							eventsEmitter.emit(StreamAIEventType.DONE);
							break;
						default: break;
					}
				} catch (error) {
					reader.releaseLock();
					eventsEmitter.emit(StreamAIEventType.ERROR, {
						error,
						generatedContent
					});
					return;
				}
			}
			readChunk();
		}).catch((error) => {
			reader.releaseLock();
			eventsEmitter.emit(StreamAIEventType.ERROR, {
				error,
				generatedContent
			});
		});
	}
	function startReading() {
		if (!startReadingCalled) {
			startReadingCalled = true;
			readChunk();
		}
	}
	setTimeout(() => {
		if (!startReadingCalled) startReading();
	}, 0);
	return {
		stream,
		events: eventsEmitter,
		startReading
	};
};

//#endregion
//#region src/services/ai.ts
const ai = (sdk) => {
	const { sdkConfig: { url } } = sdk;
	const httpClient = sdk.httpClient;
	return {
		streamAiConversationResponse: async (payload, abortSignal) => {
			const endpoint = `${url}/v4/ai/conversation`;
			return processStream(await httpClient.stream(endpoint, {
				payload,
				abortSignal
			}));
		},
		generateSuggestions: async (payload) => {
			const endpoint = `${url}/v4/ai/suggestions`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		uploadAttachment: async (formData, abortSignal) => {
			const endpoint = `${url}/v4/ai/attachments`;
			return (await httpClient.post(endpoint, {
				payload: formData,
				abortSignal
			})).data;
		},
		getAttachment: async (attachmentHashName) => {
			const endpoint = `${url}/v4/ai/attachments/${attachmentHashName}`;
			return (await httpClient.get(endpoint)).data;
		},
		getAttachmentsRemainingLimit: async () => {
			const endpoint = `${url}/v4/ai/attachments/remainingLimit`;
			return (await httpClient.get(endpoint)).data;
		},
		getGeneratedImagesRemainingLimit: async () => {
			const endpoint = `${url}/v4/ai/generatedImages/remainingLimit`;
			return (await httpClient.get(endpoint)).data;
		},
		getPromptsRemainingLimit: async () => {
			const endpoint = `${url}/v4/ai/prompts/remainingLimit`;
			return (await httpClient.get(endpoint)).data;
		},
		getGeneratedDocument: async (documentId) => {
			const endpoint = `${url}/v4/ai/documents/${documentId}`;
			return (await httpClient.get(endpoint)).data;
		},
		getGeneratedArtifacts: async (query) => {
			const endpoint = `${url}/v4/ai/generatedArtifacts`;
			return (await httpClient.get(endpoint, { query })).data;
		},
		updateGeneratedDocument: async (documentId, payload) => {
			const endpoint = `${url}/v4/ai/documents/${documentId}`;
			await httpClient.put(endpoint, { payload });
		},
		createPublicDocumentLink: async (documentId) => {
			const endpoint = `${url}/v4/ai/documents/${documentId}/publicLink`;
			return (await httpClient.post(endpoint)).data;
		},
		getPublicDocument: async (accessToken) => {
			const endpoint = `${url}/v4/ai/documents/public/${accessToken}`;
			return (await httpClient.get(endpoint)).data;
		},
		createPublicPodcastLink: async (podcastId) => {
			const endpoint = `${url}/v4/ai/generatedPodcasts/${podcastId}/publicLink`;
			return (await httpClient.post(endpoint)).data;
		},
		getPublicPodcast: async (accessToken) => {
			const endpoint = `${url}/v4/ai/generatedPodcasts/public/${accessToken}`;
			return (await httpClient.get(endpoint)).data;
		},
		uploadImage: async (formData, abortSignal) => {
			const endpoint = `${url}/v4/ai/images`;
			return (await httpClient.post(endpoint, {
				payload: formData,
				abortSignal
			})).data;
		},
		getGeneratedPodcast: async (podcastId, query) => {
			const endpoint = `${url}/v4/ai/generatedPodcasts/${podcastId}`;
			return (await httpClient.get(endpoint, { query })).data;
		},
		updateGeneratedPodcast: async (podcastId, payload) => {
			const endpoint = `${url}/v4/ai/generatedPodcasts/${podcastId}`;
			await httpClient.put(endpoint, { payload });
		},
		regenerateGeneratedPodcast: async (podcastId) => {
			const endpoint = `${url}/v4/ai/generatedPodcasts/${podcastId}/regenerate`;
			return (await httpClient.post(endpoint)).data;
		},
		stopConversationGeneration: async (conversationId, podcastId) => {
			const endpoint = `${url}/v4/ai/conversations/${conversationId}/stopGeneration`;
			await httpClient.post(endpoint, podcastId ? { payload: { podcastId } } : void 0);
		}
	};
};
var ai_default = ai;

//#endregion
//#region src/services/auth.ts
const auth = (sdk) => {
	const { sdkConfig: { url, tokenProvider }, defaultVersion } = sdk;
	const httpClient = sdk.httpClient;
	return {
		keycloakLogin: async (code) => {
			const endpoint = `${url}/${defaultVersion}/auth/keycloak`;
			const response = await httpClient.post(endpoint, {
				auth: false,
				payload: { code }
			});
			if (tokenProvider === null || tokenProvider === void 0 ? void 0 : tokenProvider.setToken) tokenProvider.setToken(response.data);
			return response.data;
		},
		facebookLogin: async (credentials) => {
			const endpoint = `${url}/${defaultVersion}/auth/facebook`;
			const response = await httpClient.post(endpoint, {
				auth: false,
				payload: credentials
			});
			if (tokenProvider === null || tokenProvider === void 0 ? void 0 : tokenProvider.setToken) tokenProvider.setToken(response.data);
			return response.data;
		},
		login: async (credentials) => {
			const endpoint = `${url}/${defaultVersion}/auth/login`;
			const response = await httpClient.post(endpoint, {
				auth: false,
				payload: credentials
			});
			if (tokenProvider === null || tokenProvider === void 0 ? void 0 : tokenProvider.setToken) tokenProvider.setToken(response.data);
			return response.data;
		},
		refresh: async (refreshToken) => {
			const endpoint = `${url}/${defaultVersion}/auth/refresh`;
			const response = await httpClient.post(endpoint, {
				auth: false,
				payload: { refreshToken }
			});
			if (tokenProvider === null || tokenProvider === void 0 ? void 0 : tokenProvider.setToken) tokenProvider.setToken(response.data);
			return response.data;
		},
		logout: async () => {
			const endpoint = `${url}/${defaultVersion}/auth/logout`;
			return (await httpClient.post(endpoint).finally(() => {
				if (tokenProvider === null || tokenProvider === void 0 ? void 0 : tokenProvider.deleteToken) tokenProvider.deleteToken();
			})).data;
		},
		validateCaptcha: async (payload) => {
			const endpoint = `${url}/${defaultVersion}/auth/captcha`;
			return (await httpClient.post(endpoint, { payload })).data;
		}
	};
};
var auth_default = auth;

//#endregion
//#region src/services/billing.ts
const paymentMethodMap = {
	creditCard: "creditCard",
	bankTransfer: "sepa",
	invoice: "invoice",
	sepa: "sepa",
	paypal: "braintree"
};
const billing = (sdk) => {
	const { sdkConfig: { url }, defaultVersion } = sdk;
	const httpClient = sdk.httpClient;
	return {
		cancelSubscription: async (userId, cancelOptions) => {
			const endpoint = `${url}/${defaultVersion}/billings/${userId}/cancelSubscription`;
			await httpClient.put(endpoint, { payload: cancelOptions });
		},
		cancelStripeSubscription: async (payload) => {
			const endpoint = `${url}/${defaultVersion}/billings/cancel-subscription`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		getSubscription: async (userId) => {
			const endpoint = `${url}/${defaultVersion}/billings/${userId}/subscription`;
			return (await httpClient.get(endpoint)).data;
		},
		getSubscriptionDetails: async () => {
			const endpoint = `${url}/${defaultVersion}/billings/subscription-details`;
			return (await httpClient.get(endpoint)).data;
		},
		getInvoices: async (userId) => {
			const endpoint = `${url}/${defaultVersion}/billings/${userId}/invoices`;
			return (await httpClient.get(endpoint)).data;
		},
		getInvoiceDownloadLink: async (userId, invoiceId) => {
			const endpoint = `${url}/${defaultVersion}/billings/${userId}/invoices/${invoiceId}`;
			return (await httpClient.get(endpoint)).data;
		},
		getUserInvoices: async () => {
			const endpoint = `${url}/${defaultVersion}/billings/invoices`;
			return (await httpClient.get(endpoint)).data;
		},
		getZuoraInvoicePdfUrl: async (invoiceNumber) => {
			const endpoint = `${url}/${defaultVersion}/billings/invoices/zuora/${encodeURIComponent(invoiceNumber)}/pdf`;
			return (await httpClient.get(endpoint)).data;
		},
		getPendingSchoolLicence: async () => {
			const endpoint = `${url}/${defaultVersion}/billings/pending-school-licence`;
			return (await httpClient.get(endpoint)).data;
		},
		getSignature: async (method, source) => {
			const endpoint = `${url}/${defaultVersion}/billings/signature/zuora`;
			const query = { method };
			if (source) query.source = source;
			return (await httpClient.get(endpoint, {
				query,
				credentials: "include"
			})).data;
		},
		getBraintreeSignature: async () => {
			const endpoint = `${url}/${defaultVersion}/billings/signature/braintree`;
			return (await httpClient.get(endpoint, { credentials: "include" })).data;
		},
		getLicenceById: async (licenceModelId) => {
			const endpoint = `${url}/${defaultVersion}/billings/licence/${licenceModelId}`;
			return (await httpClient.get(endpoint)).data;
		},
		getPaymentMethod: async (userId) => {
			const endpoint = `${url}/${defaultVersion}/billings/${userId}/paymentMethod`;
			return (await httpClient.get(endpoint)).data;
		},
		updatePaymentMethod: async (userId, method) => {
			const endpoint = `${url}/${defaultVersion}/billings/${userId}/paymentMethod`;
			return (await httpClient.put(endpoint, { payload: method })).data;
		},
		updatePaymentPeriod: async (userId, paymentPeriod) => {
			const endpoint = `${url}/${defaultVersion}/billings/${userId}/paymentPeriod`;
			const payload = { paymentPeriod };
			await httpClient.put(endpoint, { payload });
		},
		getDiscountInformation: async (promoCode, licenceId) => {
			const endpoint = `${url}/${defaultVersion}/billings/promoCode/${promoCode}/discountInformation/${licenceId}`;
			return (await httpClient.get(endpoint)).data;
		},
		getActiveLicences: async () => {
			const endpoint = `${url}/${defaultVersion}/billings/licence`;
			return (await httpClient.get(endpoint, { credentials: "include" })).data;
		},
		addTrialDiscount: async (userId) => {
			const endpoint = `${url}/${defaultVersion}/billings/${userId}/addTrialDiscount`;
			await httpClient.post(endpoint);
		},
		createPortalSession: async (returnUrl) => {
			const endpoint = `${url}/${defaultVersion}/billings/portal-session`;
			return (await httpClient.post(endpoint, { payload: { returnUrl } })).data;
		},
		createCheckoutSession: async (payload) => {
			const endpoint = `${url}/${defaultVersion}/billings/checkout-session`;
			return (await httpClient.post(endpoint, {
				auth: false,
				payload
			})).data;
		},
		updateCheckoutSession: async (sessionId, payload) => {
			const endpoint = `${url}/${defaultVersion}/billings/checkout-session/${sessionId}`;
			await httpClient.put(endpoint, {
				auth: false,
				payload
			});
		},
		getCheckoutStatus: async (sessionId) => {
			const endpoint = `${url}/${defaultVersion}/billings/checkout-session/${sessionId}/status`;
			return (await httpClient.get(endpoint)).data;
		},
		checkEmail: async (payload) => {
			const endpoint = `${url}/${defaultVersion}/billings/check-email`;
			return (await httpClient.post(endpoint, {
				auth: false,
				payload
			})).data;
		},
		getUpgradeOptions: async () => {
			const endpoint = `${url}/${defaultVersion}/billings/upgrade-options`;
			return (await httpClient.get(endpoint)).data;
		},
		getUpgradePreview: async (targetPlanKey) => {
			const endpoint = `${url}/${defaultVersion}/billings/upgrade-preview/${targetPlanKey}`;
			return (await httpClient.get(endpoint)).data;
		},
		upgradePlan: async (payload) => {
			const endpoint = `${url}/${defaultVersion}/billings/upgrade`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		resubscribeCheckoutSession: async (payload) => {
			const endpoint = `${url}/${defaultVersion}/billings/resubscribe-checkout-session`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		submitRevocation: async (payload) => {
			const endpoint = `${url}/${defaultVersion}/billings/revocation-request`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		submitPauseRequest: async (payload) => {
			const endpoint = `${url}/${defaultVersion}/billings/pause-request`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		revokeCancellation: async () => {
			const endpoint = `${url}/${defaultVersion}/billings/revoke-cancellation`;
			return (await httpClient.post(endpoint)).data;
		}
	};
};
var billing_default = billing;

//#endregion
//#region src/services/collection.ts
const collection = (sdk) => {
	const { sdkConfig: { url }, defaultVersion } = sdk;
	const httpClient = sdk.httpClient;
	return {
		addItemToCollection: async (collectionId, itemType, itemId) => {
			const endpoint = `${url}/${defaultVersion}/collections/${collectionId}/${itemType}s`;
			const payload = {};
			if (itemType === "mindItem") payload.mindItem = itemId;
			else payload.productId = itemId;
			return (await httpClient.put(endpoint, { payload })).data;
		},
		createCollection: async (payload) => {
			const endpoint = `${url}/${defaultVersion}/collections/`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		deleteCollection: async (collectionId) => {
			const endpoint = `${url}/${defaultVersion}/collections/${collectionId}`;
			return (await httpClient.delete(endpoint)).data;
		},
		deleteItemFromCollection: async (collectionId, itemType, itemId) => {
			const endpoint = `${url}/${defaultVersion}/collections/${collectionId}/${itemType}s/${itemId}`;
			return (await httpClient.delete(endpoint)).data;
		},
		getCollectionById: async (collectionId) => {
			const endpoint = `${url}/${defaultVersion}/collections/${collectionId}`;
			return (await httpClient.get(endpoint)).data;
		},
		getCollectionContentsByCollectionId: async (collectionId, pagination) => {
			const endpoint = `${url}/${defaultVersion}/collections/${collectionId}/contents`;
			return await httpClient.get(endpoint, { query: pagination });
		},
		getCuratedCollections: async () => {
			const endpoint = `${url}/${defaultVersion}/collections/curated`;
			return (await httpClient.get(endpoint)).data;
		},
		updateCollection: async (collectionId, payload) => {
			const endpoint = `${url}/${defaultVersion}/collections/${collectionId}`;
			return (await httpClient.put(endpoint, { payload })).data;
		},
		addFollower: async (collectionId, userId) => {
			const endpoint = `${url}/${defaultVersion}/collections/${collectionId}/followers/${userId}`;
			return (await httpClient.put(endpoint)).data;
		},
		deleteFollower: async (collectionId, userId) => {
			const endpoint = `${url}/${defaultVersion}/collections/${collectionId}/followers/${userId}`;
			return (await httpClient.delete(endpoint)).data;
		}
	};
};
var collection_default = collection;

//#endregion
//#region src/services/conversation.ts
const conversation = (sdk) => {
	const { sdkConfig: { url } } = sdk;
	const httpClient = sdk.httpClient;
	return {
		saveConversationMessageSentiment: async (conversationId, payload) => {
			const endpoint = `${url}/v4/conversations/${conversationId}/sentiment`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		getConversations: async (payload) => {
			const endpoint = `${url}/v4/conversations`;
			return await httpClient.get(endpoint, { query: payload });
		},
		deleteConversation: async (conversationId) => {
			const endpoint = `${url}/v4/conversations/${conversationId}`;
			return (await httpClient.delete(endpoint)).data;
		},
		getConversation: async (conversationId) => {
			const endpoint = `${url}/v4/conversations/${conversationId}`;
			return (await httpClient.get(endpoint)).data;
		}
	};
};
var conversation_default = conversation;

//#endregion
//#region src/services/corrections.ts
const corrections = (sdk) => {
	const { sdkConfig: { url } } = sdk;
	const httpClient = sdk.httpClient;
	return {
		uploadMaterial: async (formData, abortSignal) => {
			const endpoint = `${url}/v4/ai/corrections/materials`;
			return (await httpClient.post(endpoint, {
				payload: formData,
				abortSignal
			})).data;
		},
		deleteMaterial: async (hashName) => {
			const endpoint = `${url}/v4/ai/corrections/materials/${hashName}`;
			await httpClient.delete(endpoint);
		},
		getRemainingLimit: async () => {
			const endpoint = `${url}/v4/ai/corrections/remainingLimit`;
			return (await httpClient.get(endpoint)).data;
		},
		createCorrection: async (payload) => {
			const endpoint = `${url}/v4/ai/corrections`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		getCorrection: async (correctionId) => {
			const endpoint = `${url}/v4/ai/corrections/${correctionId}`;
			return (await httpClient.get(endpoint)).data;
		},
		updateCorrection: async (correctionId, payload) => {
			const endpoint = `${url}/v4/ai/corrections/${correctionId}`;
			return (await httpClient.put(endpoint, { payload })).data;
		},
		uploadStudentWorkFile: async (formData, abortSignal) => {
			const endpoint = `${url}/v4/ai/corrections/studentWorks/files`;
			return (await httpClient.post(endpoint, {
				payload: formData,
				abortSignal
			})).data;
		},
		deleteStudentWorkFile: async (hashName) => {
			const endpoint = `${url}/v4/ai/corrections/studentWorks/files/${hashName}`;
			await httpClient.delete(endpoint);
		},
		addStudentWork: async (correctionId, payload) => {
			const endpoint = `${url}/v4/ai/corrections/${correctionId}/studentWorks`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		removeStudentWork: async (correctionId, studentWorkId) => {
			const endpoint = `${url}/v4/ai/corrections/${correctionId}/studentWorks/${studentWorkId}`;
			return (await httpClient.delete(endpoint)).data;
		},
		getStudentWork: async (correctionId, studentWorkId) => {
			const endpoint = `${url}/v4/ai/corrections/${correctionId}/studentWorks/${studentWorkId}`;
			return (await httpClient.get(endpoint)).data;
		},
		evaluateCorrection: async (correctionId, payload) => {
			const endpoint = `${url}/v4/ai/corrections/${correctionId}/evaluate`;
			return (await httpClient.post(endpoint, { payload })).data;
		}
	};
};
var corrections_default = corrections;

//#endregion
//#region src/services/course.ts
const course = (sdk) => {
	const { sdkConfig: { url }, defaultVersion } = sdk;
	const httpClient = sdk.httpClient;
	return {
		createCourseRegistration: async (mindItemId) => {
			const endpoint = `${url}/v4/mindItems/${mindItemId}/courseRegistration`;
			await httpClient.put(endpoint);
		},
		getCourseRegistration: async (mindItemId) => {
			const endpoint = `${url}/v4/mindItems/${mindItemId}/courseRegistration`;
			return (await httpClient.get(endpoint)).data;
		},
		buildCourseLaunchLink: async (mindItemId) => {
			const endpoint = `${url}/v4/mindItems/${mindItemId}/courseLaunchLink`;
			return (await httpClient.get(endpoint)).data;
		},
		getCertifiedCourseRegistrations: async (userId) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/certifiedCourseRegistrations`;
			return (await httpClient.get(endpoint)).data;
		},
		getUpdatedCourseRegistration: async (userId, payload) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/courseRegistration`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		getUserCourses: async (userId, query) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/courses`;
			return await httpClient.get(endpoint, { query });
		}
	};
};
var course_default = course;

//#endregion
//#region src/services/document.ts
const document = (sdk) => {
	const { sdkConfig: { url } } = sdk;
	const httpClient = sdk.httpClient;
	return {
		convertHtmlToPdf: async (html) => {
			const endpoint = `${url}/v4/document/convert-html-to-pdf`;
			return (await httpClient.post(endpoint, { payload: { html } })).data;
		},
		convertHtmlToPdfPublic: async (html, accessToken) => {
			const endpoint = `${url}/v4/document/convert-html-to-pdf-public`;
			return (await httpClient.post(endpoint, {
				payload: {
					html,
					accessToken
				},
				auth: false
			})).data;
		},
		convertHtmlToDocx: async (html) => {
			const endpoint = `${url}/v4/document/convert-html-to-docx`;
			return (await httpClient.post(endpoint, { payload: { html } })).data;
		}
	};
};
var document_default = document;

//#endregion
//#region src/services/email.ts
const email = (sdk) => {
	const { sdkConfig: { url }, defaultVersion } = sdk;
	const httpClient = sdk.httpClient;
	return {
		resendConfirmationEmail: async (email$1) => {
			const endpoint = `${url}/${defaultVersion}/emails/resendConfirmation`;
			return (await httpClient.post(endpoint, {
				auth: false,
				payload: { email: email$1 }
			})).data;
		},
		isFakeEmail: async (email$1) => {
			const endpoint = `${url}/${defaultVersion}/emails/${email$1}/isFakeEmail`;
			return (await httpClient.get(endpoint)).data;
		}
	};
};
var email_default = email;

//#endregion
//#region \0@oxc-project+runtime@0.107.0/helpers/typeof.js
function _typeof(o) {
	"@babel/helpers - typeof";
	return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
		return typeof o$1;
	} : function(o$1) {
		return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
	}, _typeof(o);
}

//#endregion
//#region \0@oxc-project+runtime@0.107.0/helpers/toPrimitive.js
function toPrimitive(t, r) {
	if ("object" != _typeof(t) || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != _typeof(i)) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}

//#endregion
//#region \0@oxc-project+runtime@0.107.0/helpers/toPropertyKey.js
function toPropertyKey(t) {
	var i = toPrimitive(t, "string");
	return "symbol" == _typeof(i) ? i : i + "";
}

//#endregion
//#region \0@oxc-project+runtime@0.107.0/helpers/defineProperty.js
function _defineProperty(e, r, t) {
	return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
		value: t,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[r] = t, e;
}

//#endregion
//#region \0@oxc-project+runtime@0.107.0/helpers/objectSpread2.js
function ownKeys(e, r) {
	var t = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var o = Object.getOwnPropertySymbols(e);
		r && (o = o.filter(function(r$1) {
			return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
		})), t.push.apply(t, o);
	}
	return t;
}
function _objectSpread2(e) {
	for (var r = 1; r < arguments.length; r++) {
		var t = null != arguments[r] ? arguments[r] : {};
		r % 2 ? ownKeys(Object(t), !0).forEach(function(r$1) {
			_defineProperty(e, r$1, t[r$1]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r$1) {
			Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
		});
	}
	return e;
}

//#endregion
//#region src/services/mindItem.ts
const mindItem = (sdk) => {
	const { sdkConfig: { url }, defaultVersion } = sdk;
	const httpClient = sdk.httpClient;
	return {
		downloadInformation: async (mindItemId, trackingInfo) => {
			const endpoint = `${url}/${defaultVersion}/mindItems/${mindItemId}/downloadInformation`;
			return (await httpClient.get(endpoint, { query: _objectSpread2({}, trackingInfo) })).data;
		},
		getMindItem: async (id) => {
			const endpoint = `${url}/v4/mindItems/${id}`;
			return (await httpClient.get(endpoint)).data;
		},
		getMindItemToken: async (id) => {
			const endpoint = `${url}/v4/mindItems/${id}/documentToken`;
			return (await httpClient.get(endpoint)).data;
		},
		getMindItemSiblings: async (id) => {
			const endpoint = `${url}/v4/mindItems/${id}/siblings`;
			return (await httpClient.get(endpoint)).data;
		},
		getPublicMindItem: async (accessToken) => {
			const endpoint = `${url}/v4/mindItems/public/${accessToken}`;
			return (await httpClient.get(endpoint)).data;
		},
		createPublicMindItemLink: async (id) => {
			const endpoint = `${url}/v4/mindItems/${id}/publicLink`;
			return (await httpClient.post(endpoint)).data;
		},
		getTopics: async (subject) => {
			const endpoint = `${url}/v4/mindItems/topics`;
			return (await httpClient.get(endpoint, { query: { subject } })).data;
		},
		manageItemInMultipleCollections: async (mindItemId, payload) => {
			const endpoint = `${url}/${defaultVersion}/mindItems/${mindItemId}/manageItemInMultipleCollections`;
			return (await httpClient.put(endpoint, { payload })).data;
		},
		pinMindItem: async (mindItemId) => {
			const endpoint = `${url}/v4/mindItems/${mindItemId}/pin`;
			return (await httpClient.put(endpoint)).data;
		},
		unpinMindItem: async (mindItemId) => {
			const endpoint = `${url}/v4/mindItems/${mindItemId}/unpin`;
			await httpClient.put(endpoint);
		},
		search: async (searchParams, abortSignal) => {
			const endpoint = `${url}/v4/mindItems/search`;
			return await httpClient.get(endpoint, {
				query: searchParams,
				abortSignal
			});
		},
		searchSuggestions: async (searchTerm, contentType, abortSignal) => {
			const endpoint = `${url}/${defaultVersion}/mindItems/search/suggestions`;
			const query = { term: searchTerm };
			if (contentType === null || contentType === void 0 ? void 0 : contentType.length) query.contentType = contentType;
			return (await httpClient.get(endpoint, {
				auth: false,
				query,
				abortSignal
			})).data;
		}
	};
};
var mindItem_default = mindItem;

//#endregion
//#region src/services/notification.ts
const notification = (sdk) => {
	const { sdkConfig: { url }, defaultVersion } = sdk;
	const httpClient = sdk.httpClient;
	return { sendSupportNotification: async (payload) => {
		const endpoint = `${url}/${defaultVersion}/notifications/support`;
		return (await httpClient.post(endpoint, { payload })).data;
	} };
};
var notification_default = notification;

//#endregion
//#region src/services/product.ts
const product = (sdk) => {
	const { sdkConfig: { url }, defaultVersion } = sdk;
	const httpClient = sdk.httpClient;
	return {
		getProduct: async (productId, query) => {
			const endpoint = `${url}/v4/products/${productId}`;
			return (await httpClient.get(endpoint, { query })).data;
		},
		getProductsByQuery: async (query = {}, options = {}) => {
			const endpoint = `${url}/v4/products`;
			return (await httpClient.get(endpoint, { query: _objectSpread2(_objectSpread2({}, query), options) })).data;
		},
		getProductMindItems: async (productId) => {
			const endpoint = `${url}/v4/products/${productId}/mindItems`;
			return (await httpClient.get(endpoint)).data;
		},
		manageItemInMultipleCollections: async (productId, payload) => {
			const endpoint = `${url}/${defaultVersion}/products/${productId}/manageItemInMultipleCollections`;
			return (await httpClient.put(endpoint, { payload })).data;
		},
		pinProduct: async (productId) => {
			const endpoint = `${url}/v4/products/${productId}/pin`;
			return (await httpClient.put(endpoint)).data;
		},
		unpinProduct: async (productId) => {
			const endpoint = `${url}/v4/products/${productId}/unpin`;
			await httpClient.put(endpoint);
		},
		getAttachments: async (productId) => {
			const endpoint = `${url}/v4/products/${productId}/attachments`;
			return (await httpClient.get(endpoint)).data;
		},
		getAttachmentZipLink: async (zipId) => {
			const endpoint = `${url}/v4/products/zip/${zipId}`;
			return (await httpClient.get(endpoint, { hideProgress: true })).data;
		},
		handleProductAttachmentsDownload: async (productId, payload) => {
			const endpoint = `${url}/v4/products/${productId}/attachments/download`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		search: async (searchParams, abortSignal) => {
			const endpoint = `${url}/v4/products/search`;
			return await httpClient.get(endpoint, {
				query: searchParams,
				abortSignal
			});
		}
	};
};
var product_default = product;

//#endregion
//#region src/services/recommendations.ts
const recommendations = (sdk) => {
	const { sdkConfig: { url }, httpClient } = sdk;
	return { getRecommendations: async ({ surface }) => {
		const endpoint = `${url}/v4/recommendations`;
		return (await httpClient.get(endpoint, { query: { surface } })).data;
	} };
};
var recommendations_default = recommendations;

//#endregion
//#region src/services/registration.ts
const registration = (sdk) => {
	const { sdkConfig: { url }, defaultVersion } = sdk;
	const httpClient = sdk.httpClient;
	return {
		confirm: async (token, payload) => {
			const endpoint = `${url}/${defaultVersion}/register/confirm/${token}`;
			return (await httpClient.put(endpoint, {
				payload,
				auth: false
			})).data;
		},
		registerLibrary: async (payload) => {
			const endpoint = `${url}/${defaultVersion}/register/library/app`;
			return (await httpClient.post(endpoint, {
				payload,
				auth: false
			})).data;
		},
		registerPremium: async (payload) => {
			const endpoint = `${url}/${defaultVersion}/register/premium/app`;
			return (await httpClient.post(endpoint, {
				payload,
				auth: false
			})).data;
		},
		registerBasis: async (payload) => {
			const endpoint = `${url}/${defaultVersion}/register`;
			return (await httpClient.post(endpoint, {
				payload,
				auth: false
			})).data;
		}
	};
};
var registration_default = registration;

//#endregion
//#region src/services/school.ts
const school = (sdk) => {
	const { sdkConfig: { url }, defaultVersion } = sdk;
	const httpClient = sdk.httpClient;
	return {
		getSchoolSeatsOverview: async (schoolId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/seatsOverview`;
			return (await httpClient.get(endpoint)).data;
		},
		getSchoolInvoiceDownloadLink: async (schoolId, invoiceId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/invoices/${invoiceId}/file`;
			return (await httpClient.get(endpoint)).data;
		},
		getSchoolInvoices: async (schoolId, page = 1, pageSize = 10) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/invoices`;
			return (await httpClient.get(endpoint, { query: {
				page,
				pageSize
			} })).data;
		},
		getSchoolTeachers: async (schoolId, page = 1, pageSize = 10, search$1 = "", refreshCache = false) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers`;
			return (await httpClient.get(endpoint, { query: {
				page,
				pageSize,
				search: search$1,
				refreshCache
			} })).data;
		},
		addTeacher: async (schoolId, payload) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		removeTeacher: async (userId, schoolId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers/${userId}`;
			return (await httpClient.delete(endpoint)).data;
		},
		removeSchoolAdmin: async (userId, schoolId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/admins/${userId}`;
			return (await httpClient.delete(endpoint)).data;
		},
		assignSchoolAdmin: async (userId, schoolId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/admins`;
			return (await httpClient.put(endpoint, { payload: { userId } })).data;
		},
		createSchoolAdmin: async (data) => {
			const endpoint = `${url}/${defaultVersion}/schools/${data.schoolId}/admins`;
			const payload = {
				firstName: data.firstName,
				lastName: data.lastName,
				email: data.email
			};
			return (await httpClient.post(endpoint, { payload })).data;
		},
		upgradeSubscription: async (schoolId, accountNumber, newLicenceId, subscriptionId, userId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers/upgrade`;
			return (await httpClient.post(endpoint, { payload: {
				accountNumber,
				newLicenceId,
				subscriptionId,
				userId
			} })).data;
		},
		resendInvitation: async (schoolId, userId, licenceModelId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers/resendInvitation`;
			return (await httpClient.post(endpoint, { payload: {
				userId,
				licenceModelId
			} })).data;
		},
		resetPassword: async (schoolId, email$1) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers/resetPassword`;
			return (await httpClient.post(endpoint, { payload: { email: email$1 } })).data;
		},
		getSchoolAdmins: async (schoolId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/admins`;
			return (await httpClient.get(endpoint)).data;
		},
		getMoreSeats: async (data) => {
			const endpoint = `${url}/${defaultVersion}/schools/${data.schoolId}/getMoreSeats`;
			return (await httpClient.post(endpoint, { payload: { seatsCount: data.seatsCount } })).data;
		},
		requestUpgradeProducts: async (schoolId, requestedProducts) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/requestUpgradeProducts`;
			return (await httpClient.post(endpoint, { payload: { requestedProducts } })).data;
		},
		updateTeacherInfo: async (id, schoolId, payload) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers/${id}`;
			return (await httpClient.put(endpoint, { payload })).data;
		},
		getStripeSchoolTeachers: async (schoolId, page = 1, pageSize = 50, search$1 = "") => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/stripe/teachers`;
			return (await httpClient.get(endpoint, { query: {
				page,
				pageSize,
				search: search$1
			} })).data;
		},
		getStripeSchoolSeats: async (schoolId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/stripe/seats`;
			return (await httpClient.get(endpoint)).data;
		},
		inviteStripeSchoolTeacher: async (schoolId, payload) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/stripe/teachers`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		inviteStripeSchoolTeachersBatch: async (schoolId, payload) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/stripe/teachers/batch`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		removeStripeSchoolTeacher: async (schoolId, muUserId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/stripe/teachers/remove`;
			return (await httpClient.post(endpoint, { payload: { muUserId } })).data;
		},
		sendStripeTeacherImportSupportRequest: async (schoolId, payload) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/stripe/teachers/support-request`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		getStripeSchoolAdmins: async (schoolId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/stripe/admins`;
			return (await httpClient.get(endpoint)).data;
		},
		createStripeSchoolAdmin: async (schoolId, payload) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/stripe/admins`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		resendStripeSchoolAdminInvitation: async (schoolId, muUserId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/stripe/admins/resend`;
			return (await httpClient.post(endpoint, { payload: { muUserId } })).data;
		},
		removeStripeSchoolAdmin: async (schoolId, muUserId) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/stripe/admins/remove`;
			return (await httpClient.post(endpoint, { payload: { muUserId } })).data;
		},
		createStripeSchoolPortalSession: async (schoolId, returnUrl) => {
			const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/stripe/portal-session`;
			return (await httpClient.post(endpoint, { payload: { returnUrl } })).data;
		}
	};
};
var school_default = school;

//#endregion
//#region src/services/search.ts
const search = (sdk) => {
	const { sdkConfig: { url } } = sdk;
	const httpClient = sdk.httpClient;
	return { unifiedSearch: async (searchParams, abortSignal) => {
		const endpoint = `${url}/v4/search/unified`;
		return await httpClient.get(endpoint, {
			query: searchParams,
			abortSignal
		});
	} };
};
var search_default = search;

//#endregion
//#region src/services/text.ts
const textService = (sdk) => {
	const { sdkConfig: { url }, httpClient } = sdk;
	return {
		getFederalStates: async () => {
			const endpoint = `${url}/v3/texts/federalStates`;
			return (await httpClient.get(endpoint)).data;
		},
		getPublishers: async () => {
			const endpoint = `${url}/v3/texts/publishers`;
			return (await httpClient.get(endpoint)).data;
		},
		getSchoolStages: async () => {
			const endpoint = `${url}/v3/texts/schoolStages`;
			return (await httpClient.get(endpoint)).data;
		},
		getSchoolTypes: async () => {
			const endpoint = `${url}/v3/texts/schoolTypes`;
			return (await httpClient.get(endpoint)).data;
		},
		getAiFilterValues: async () => {
			const endpoint = `${url}/v3/texts/aiFilterValues`;
			return (await httpClient.get(endpoint)).data;
		},
		getWorkloads: async () => {
			const endpoint = `${url}/v3/texts/workloads`;
			return (await httpClient.get(endpoint)).data;
		},
		getTeachingFormats: async () => {
			const endpoint = `${url}/v3/texts/teachingFormats`;
			return (await httpClient.get(endpoint)).data;
		},
		getTeacherRoles: async () => {
			const endpoint = `${url}/v3/texts/teacherRoles`;
			return (await httpClient.get(endpoint)).data;
		},
		getSchools: async (payload) => {
			const endpoint = `${url}/v3/texts/schoolDetails`;
			try {
				var _response$data;
				const response = await httpClient.post(endpoint, { payload: _objectSpread2(_objectSpread2({}, payload), {}, {
					includedType: "school",
					strictTypeFiltering: true,
					languageCode: "de"
				}) });
				return (_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : [];
			} catch (_unused) {
				throw new Error("Failed to fetch school details");
			}
		}
	};
};
var text_default = textService;

//#endregion
//#region src/services/track.ts
const track = (sdk) => {
	const { sdkConfig: { url } } = sdk;
	const httpClient = sdk.httpClient;
	return { trackEvent: async (isPublic, payload) => {
		return (await httpClient.post(`${url}/v4/track`, {
			payload,
			query: { isPublic },
			auth: !isPublic
		})).data;
	} };
};
var track_default = track;

//#endregion
//#region src/services/user.ts
const user = (sdk) => {
	const { sdkConfig: { url }, defaultVersion } = sdk;
	const httpClient = sdk.httpClient;
	return {
		getMe: async () => {
			const endpoint = `${url}/${defaultVersion}/me`;
			return (await httpClient.get(endpoint)).data;
		},
		upgrade: async (userId, payload) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/upgrade`;
			return (await httpClient.put(endpoint, { payload })).data;
		},
		upgradeFromCoursesToKombi: async (userId, payload) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/upgradeAccountSubscriptionToKombi`;
			return (await httpClient.post(endpoint, { payload })).data;
		},
		canCreateSubscription: async (email$1) => {
			const endpoint = `${url}/${defaultVersion}/users/can-create-subscription`;
			return (await httpClient.get(endpoint, {
				auth: false,
				query: { email: email$1 }
			})).data;
		},
		hasValidLibraryDomain: async (email$1, library) => {
			const endpoint = `${url}/${defaultVersion}/users/library/validDomain`;
			return (await httpClient.get(endpoint, {
				auth: false,
				query: {
					email: email$1,
					library
				}
			})).data;
		},
		getLibraryIpRange: async (library) => {
			const endpoint = `${url}/${defaultVersion}/users/library/ipRange`;
			return (await httpClient.get(endpoint, {
				auth: false,
				query: { library }
			})).data;
		},
		confirmChangeEmail: async (token) => {
			const endpoint = `${url}/${defaultVersion}/users/changeEmail/confirm`;
			await httpClient.put(endpoint, { payload: { token } });
		},
		changeEmail: async (oldEmail, newEmail, password, isLibraryEmail) => {
			const endpoint = `${url}/${defaultVersion}/users/changeEmail`;
			const payload = {
				oldEmail,
				newEmail,
				password,
				isLibraryEmail
			};
			await httpClient.put(endpoint, { payload });
		},
		existsByQuery: async (query) => {
			const endpoint = `${url}/${defaultVersion}/users/exists`;
			return (await httpClient.get(endpoint, {
				auth: false,
				query
			})).data;
		},
		getUserByToken: async (query) => {
			const endpoint = `${url}/${defaultVersion}/users/exists/token`;
			return (await httpClient.get(endpoint, { query })).data;
		},
		getCollections: async (userId) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/collections`;
			return (await httpClient.get(endpoint)).data;
		},
		getPinnedDocuments: async (userId) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/pinnedDocuments`;
			return (await httpClient.get(endpoint)).data;
		},
		getPinnedContents: async (userId, pagination) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/pinnedDocuments/contents`;
			return await httpClient.get(endpoint, { query: pagination });
		},
		getRecentlyViewed: async (userId, pagination) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/recentlyViewed/contents`;
			return await httpClient.get(endpoint, { query: pagination });
		},
		getSubscriptionUpgradePreview: async (userId, licence) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/licence/${licence}/getKombiSubscriptionUpgradePreview`;
			return (await httpClient.get(endpoint)).data;
		},
		getDownloadContents: async (userId, pagination) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/downloadList/contents`;
			return await httpClient.get(endpoint, { query: pagination });
		},
		getDownloadList: async (userId) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/downloadList`;
			return await httpClient.get(endpoint);
		},
		update: async (userId, payload) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}`;
			return (await httpClient.put(endpoint, { payload })).data;
		},
		updateNewsletter: async (userId, payload) => {
			const endpoint = `${url}/v3/users/${userId}/newsletter`;
			return (await httpClient.put(endpoint, { payload })).data;
		},
		recordTriggeredHint: async (userId, payload) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/triggered-hints`;
			return (await httpClient.put(endpoint, { payload })).data;
		},
		recordCampaignImpression: async (userId, payload) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/campaign-impressions`;
			return (await httpClient.put(endpoint, { payload })).data;
		},
		initPasswordReset: async (email$1) => {
			const endpoint = `${url}/${defaultVersion}/users/passwordReset`;
			await httpClient.post(endpoint, { payload: { email: email$1 } });
		},
		resetPassword: async (password, passwordRepeat, token) => {
			const endpoint = `${url}/${defaultVersion}/users/resetPassword`;
			return (await httpClient.put(endpoint, { payload: {
				password,
				passwordRepeat,
				token
			} })).data;
		},
		changePassword: async (password, newPassword, newPasswordRepeat) => {
			const endpoint = `${url}/${defaultVersion}/users/changePassword`;
			return (await httpClient.put(endpoint, { payload: {
				password,
				newPassword,
				newPasswordRepeat
			} })).data;
		},
		getExperimentData: async (userId, experiment) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/experiments`;
			return (await httpClient.get(endpoint, { query: { name: experiment } })).data;
		},
		trackExperiment: async (userId, experiment) => {
			const endpoint = `${url}/${defaultVersion}/users/${userId}/experiments`;
			return (await httpClient.put(endpoint, { payload: experiment })).data;
		}
	};
};
var user_default = user;

//#endregion
//#region src/services/index.ts
var services_default = {
	admin: admin_default,
	ai: ai_default,
	auth: auth_default,
	billing: billing_default,
	collection: collection_default,
	course: course_default,
	document: document_default,
	email: email_default,
	mindItem: mindItem_default,
	notification: notification_default,
	product: product_default,
	recommendations: recommendations_default,
	registration: registration_default,
	school: school_default,
	search: search_default,
	text: text_default,
	track: track_default,
	user: user_default,
	conversation: conversation_default,
	corrections: corrections_default
};

//#endregion
//#region src/utils/ApiError.ts
var ApiError = class extends Error {
	constructor(message, statusCode, data) {
		super(message);
		this.data = data;
		this.statusCode = statusCode;
	}
};

//#endregion
//#region src/utils/request.ts
const stringifyQuery = (query) => {
	Object.entries(query).forEach(([key, value]) => {
		if (Array.isArray(value)) query[key] = value.join(",");
	});
};
const createClient = (client) => (realm, getToken, progress) => {
	let requestsInProgress = 0;
	const progressInc = () => progress === null || progress === void 0 ? void 0 : progress.inc();
	const progressDone = () => progress === null || progress === void 0 ? void 0 : progress.done();
	const request = async (method, url, payload, auth$1 = true, headers, query = {}, hideProgress, abortSignal, credentials) => {
		if (url.indexOf("?") !== -1) throw new Error("Use query parameter instead of having query in url");
		const options = {
			headers: {
				"Content-Type": "application/json",
				Realm: realm
			},
			method
		};
		if (payload instanceof FormData) {
			options.body = payload;
			delete options.headers["Content-Type"];
		} else if (payload) options.body = JSON.stringify(payload);
		if (auth$1) options.headers.Authorization = getToken();
		if (headers) options.headers = _objectSpread2(_objectSpread2({}, options.headers), headers);
		if (abortSignal) options.signal = abortSignal;
		if (credentials) options.credentials = credentials;
		if (query) stringifyQuery(query);
		try {
			if (!hideProgress) {
				requestsInProgress++;
				progressInc();
			}
			const response = await client(`${url}?${queryString.stringify(query)}`, options);
			if (response.status <= 300 && response.statusText === "No Content" || response.status === 204) return { status: response.status };
			if (response.status >= 300) {
				const json = await response.json();
				const { error, message } = json;
				throw new ApiError(`${error} - ${message}`, response.status, json);
			}
			const contentType = response.headers.get("Content-Type") || "";
			if (contentType.includes("application/pdf") || contentType.includes("application/vnd.openxmlformats-officedocument")) return {
				data: await response.blob(),
				meta: {}
			};
			const { data, meta } = await response.json();
			return {
				data,
				meta
			};
		} finally {
			if (!hideProgress) {
				requestsInProgress--;
				if (requestsInProgress) progressInc();
				else progressDone();
			}
		}
	};
	const streamRequest = async (method, url, payload, auth$1 = true, headers, query = {}, abortSignal) => {
		if (url.indexOf("?") !== -1) throw new Error("Use query parameter instead of having query in url");
		const options = {
			headers: {
				"Content-Type": "application/json",
				Realm: realm,
				Accept: "text/event-stream"
			},
			method
		};
		if (payload instanceof FormData) {
			options.body = payload;
			delete options.headers["Content-Type"];
		} else if (payload) options.body = JSON.stringify(payload);
		if (auth$1) options.headers.Authorization = getToken();
		if (headers) options.headers = _objectSpread2(_objectSpread2({}, options.headers), headers);
		if (abortSignal) options.signal = abortSignal;
		if (query) stringifyQuery(query);
		const response = await client(`${url}?${queryString.stringify(query)}`, options);
		if (!response.ok || !response.body) {
			const json = await response.json();
			const { error, message } = json;
			throw new ApiError(`${error} - ${message}`, response.status, json);
		}
		return response.body;
	};
	return {
		delete: async (url, options = {}) => request("delete", url, options.payload, options.auth, options.headers, options.query, options.hideProgress, options.abortSignal, options.credentials),
		get: async (url, options = {}) => request("get", url, void 0, options.auth, options.headers, options.query, options.hideProgress, options.abortSignal, options.credentials),
		put: async (url, options = {}) => request("put", url, options.payload, options.auth, options.headers, options.query, options.hideProgress, options.abortSignal, options.credentials),
		post: async (url, options = {}) => request("post", url, options.payload, options.auth, options.headers, options.query, options.hideProgress, options.abortSignal, options.credentials),
		stream: async (url, options = {}) => streamRequest("post", url, options.payload, options.auth, options.headers, options.query, options.abortSignal)
	};
};
var request_default = createClient(fetch);

//#endregion
//#region src/constants/billing.ts
/**
* Canonical plan-key catalogue for the checkout / upgrade flow (SM-325).
*
* This module is the single source of truth for the FE-facing plan keys:
* the `CheckoutPlan` / `PlanKey` types are derived from the runtime tuples
* below, and consumers (e.g. the web app) import the tuples to build their own
* validation allow-lists instead of re-declaring the literal list. A rename or
* a new plan is now a one-line edit here.
*/
/**
* Every checkoutable plan key, in catalogue order. Each maps 1:1 to a Stripe
* product bundle. Excludes the free `basis` tier, which is not checkoutable.
*/
const CHECKOUT_PLANS = [
	"pro",
	"courseOnly",
	"aiOnly",
	"fullAccess"
];
/**
* Every plan key including the free `basis` tier. The upgrade flow uses this
* superset of `CHECKOUT_PLANS` to describe both a user's current and target
* plans (`basis` is a valid *current* plan but never a valid upgrade target).
*/
const PLAN_KEYS = ["basis", ...CHECKOUT_PLANS];

//#endregion
//#region src/models/common/Conversation.ts
let TemplatePrompts = /* @__PURE__ */ function(TemplatePrompts$1) {
	TemplatePrompts$1["CREATE_ADDITIONAL_TASKS"] = "CREATE_ADDITIONAL_TASKS";
	TemplatePrompts$1["CREATE_SUPPLEMENTAL_AIDS"] = "CREATE_SUPPLEMENTAL_AIDS";
	TemplatePrompts$1["CREATE_LESSON_PLAN"] = "CREATE_LESSON_PLAN";
	TemplatePrompts$1["CREATE_QUIZ"] = "CREATE_QUIZ";
	TemplatePrompts$1["CREATE_DIFFERENTIATED_TASKS"] = "CREATE_DIFFERENTIATED_TASKS";
	TemplatePrompts$1["CREATE_INTRODUCTORY_LESSON"] = "CREATE_INTRODUCTORY_LESSON";
	TemplatePrompts$1["CREATE_SUMMARY"] = "CREATE_SUMMARY";
	TemplatePrompts$1["CREATE_SIMPLIFIED_LANGUAGE"] = "CREATE_SIMPLIFIED_LANGUAGE";
	TemplatePrompts$1["CREATE_LEARNING_POSTER"] = "CREATE_LEARNING_POSTER";
	TemplatePrompts$1["CREATE_WORKSHEET_FREE_DRAFT"] = "CREATE_WORKSHEET_FREE_DRAFT";
	TemplatePrompts$1["CREATE_LESSON_PLAN_FREE_DRAFT"] = "CREATE_LESSON_PLAN_FREE_DRAFT";
	TemplatePrompts$1["CREATE_GROUP_WORK_FREE_DRAFT"] = "CREATE_GROUP_WORK_FREE_DRAFT";
	TemplatePrompts$1["CREATE_TOPIC_EXPLANATION_FREE_DRAFT"] = "CREATE_TOPIC_EXPLANATION_FREE_DRAFT";
	TemplatePrompts$1["CREATE_LESSON_SERIES_FREE_DRAFT"] = "CREATE_LESSON_SERIES_FREE_DRAFT";
	TemplatePrompts$1["CREATE_LEARNING_OBJECTIVE_ASSERTION_FREE_DRAFT"] = "CREATE_LEARNING_OBJECTIVE_ASSERTION_FREE_DRAFT";
	TemplatePrompts$1["CREATE_ESSAY_FREE_DRAFT"] = "CREATE_ESSAY_FREE_DRAFT";
	TemplatePrompts$1["CREATE_IMAGE"] = "CREATE_IMAGE";
	TemplatePrompts$1["CREATE_PODCAST"] = "CREATE_PODCAST";
	return TemplatePrompts$1;
}({});
let ConversationType = /* @__PURE__ */ function(ConversationType$1) {
	ConversationType$1["MIND_ITEM"] = "mindItem";
	ConversationType$1["FREE_FORM"] = "freeForm";
	ConversationType$1["UPLOADED_FILE"] = "uploadedFile";
	return ConversationType$1;
}({});

//#endregion
//#region src/models/requests/Ai.ts
const ClassYears = [
	"1st",
	"2nd",
	"3rd",
	"4th",
	"5th",
	"6th",
	"7th",
	"8th",
	"9th",
	"10th",
	"11th",
	"12th",
	"13th"
];
const Languages = [
	"German",
	"English",
	"Spanish",
	"French"
];
let SuggestionsType = /* @__PURE__ */ function(SuggestionsType$1) {
	SuggestionsType$1["TOPIC"] = "topic";
	SuggestionsType$1["LEARNING_GOAL"] = "learning_goal";
	return SuggestionsType$1;
}({});
let SuggestionsDataKey = /* @__PURE__ */ function(SuggestionsDataKey$1) {
	SuggestionsDataKey$1["TOPIC"] = "topic";
	SuggestionsDataKey$1["LEARNING_GOAL"] = "learningGoal";
	SuggestionsDataKey$1["CLASS_YEAR"] = "grade";
	SuggestionsDataKey$1["SUBJECT"] = "subject";
	return SuggestionsDataKey$1;
}({});

//#endregion
//#region src/models/requests/Search.ts
let SearchExperiment = /* @__PURE__ */ function(SearchExperiment$1) {
	SearchExperiment$1["DeepLinking"] = "deep-linking";
	SearchExperiment$1["DemoteReadOnly"] = "demote-read-only";
	return SearchExperiment$1;
}({});

//#endregion
//#region src/models/responses/Corrections.ts
let CorrectionStatus = /* @__PURE__ */ function(CorrectionStatus$1) {
	CorrectionStatus$1["LOADING"] = "loading";
	CorrectionStatus$1["READY"] = "ready";
	CorrectionStatus$1["ERROR"] = "error";
	return CorrectionStatus$1;
}({});
/** Models a correction can be pinned to, per phase. */
let CorrectionModel = /* @__PURE__ */ function(CorrectionModel$1) {
	CorrectionModel$1["GEMINI_3_1_FLASH_LITE"] = "gemini-3.1-flash-lite";
	CorrectionModel$1["GEMINI_3_5_FLASH_LITE"] = "gemini-3.5-flash-lite";
	CorrectionModel$1["GEMINI_3_5_FLASH"] = "gemini-3.5-flash";
	CorrectionModel$1["GPT_5_6_LUNA"] = "gpt-5.6-luna";
	CorrectionModel$1["GPT_6_LUNA"] = "gpt-6-luna";
	CorrectionModel$1["CLAUDE_HAIKU_5_5"] = "claude-haiku-5.5";
	return CorrectionModel$1;
}({});
/** Cheapest first. Gemini models accept MINIMAL to HIGH; XHIGH and MAX are for the GPT and Claude models only. */
let CorrectionThinkingLevel = /* @__PURE__ */ function(CorrectionThinkingLevel$1) {
	CorrectionThinkingLevel$1["MINIMAL"] = "MINIMAL";
	CorrectionThinkingLevel$1["LOW"] = "LOW";
	CorrectionThinkingLevel$1["MEDIUM"] = "MEDIUM";
	CorrectionThinkingLevel$1["HIGH"] = "HIGH";
	CorrectionThinkingLevel$1["XHIGH"] = "XHIGH";
	CorrectionThinkingLevel$1["MAX"] = "MAX";
	return CorrectionThinkingLevel$1;
}({});

//#endregion
//#region src/index.ts
var SDK = class {
	constructor(sdkConfig) {
		this.sdkConfig = sdkConfig;
		this.defaultVersion = "v3";
		this.httpClient = request_default(sdkConfig.realm, this.getToken.bind(this), sdkConfig.progress);
		this.admin = services_default.admin(this);
		this.auth = services_default.auth(this);
		this.billing = services_default.billing(this);
		this.collection = services_default.collection(this);
		this.course = services_default.course(this);
		this.conversation = services_default.conversation(this);
		this.corrections = services_default.corrections(this);
		this.document = services_default.document(this);
		this.email = services_default.email(this);
		this.mindItem = services_default.mindItem(this);
		this.notification = services_default.notification(this);
		this.product = services_default.product(this);
		this.recommendations = services_default.recommendations(this);
		this.school = services_default.school(this);
		this.search = services_default.search(this);
		this.registration = services_default.registration(this);
		this.text = services_default.text(this);
		this.track = services_default.track(this);
		this.user = services_default.user(this);
		this.ai = services_default.ai(this);
	}
	getToken() {
		if (!this.sdkConfig.tokenProvider) throw new Error("Authenticated endpoint: Must define a token provider");
		return `${this.sdkConfig.tokenProvider.type || "token"} ${this.sdkConfig.tokenProvider.getToken()}`;
	}
};
var src_default = SDK;

//#endregion
export { ApiError, AssistantStreamEmitter, CHECKOUT_PLANS, ClassYears, ConversationType, CorrectionModel, CorrectionStatus, CorrectionThinkingLevel, GeneratedArtifactType, GeneratedPodcastStageStatus, Languages, PLAN_KEYS, SearchExperiment, StreamAIEventType, SuggestionsDataKey, SuggestionsType, TemplatePrompts, createClient, src_default as default, paymentMethodMap, processStream };
//# sourceMappingURL=index.js.map